import { memo, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { TextField, WithTooltip } from 'basic-components';
import { Hidden, Visible } from 'basic-components/icons';

import properties from 'resources/constants/properties.json';

import { Else, If, Then, When } from 'react-if';

import './Password.scss';

/* eslint-disable no-unused-vars */
const Password = ({
  value,
  valueType,
  validators,
  onChange,
  size = undefined,
  menuPosition = undefined,
  animationEnded = undefined,
  withShowPassword = false,
  dependsOnParam = undefined,
  extraGroupQuery = undefined,
  referenceDependsOnParam,
  withProvider,
  readableName,
  ref,
  ...props
}) => {
/* eslint-enable no-unused-vars */
  const [isPasswordVisible, setIsPasswordVisible] = useState(false),
        hidePassword = useCallback(() => setIsPasswordVisible(false), []),
        showPassword = useCallback(() => setIsPasswordVisible(true), []),
        shouldShowEye = useMemo(() => withShowPassword && properties.allowShowingPasswordParams === "true", [withShowPassword])

  return (
    <div className="data-science__pipeline-creator__body__options__resolver__bottom-row__password">
      <TextField
          {...props}
          autoComplete="new-password"
          defaultValue={value ? String(value) : value}
          onChange={onChange}
          placeholder="Type password"
          ref={ref}
          size={size}
          type={isPasswordVisible ? undefined : "password"}
          validators={validators}
      />
      <When condition={shouldShowEye}>
        {() => (
          <If condition={isPasswordVisible}>
            <Then>
              {() => (
                <WithTooltip
                    data-place="top"
                    short
                    text="Hide"
                >
                  <div 
                      className="data-science__pipeline-creator__body__options__resolver__bottom-row__password__icon"
                      onClick={hidePassword}
                  >
                    <Hidden
                        color="blue-bright"
                        height={16}
                        width={16}
                    />
                  </div>
                </WithTooltip>
              )}
            </Then>
            <Else>
              {() => (
                <WithTooltip
                    data-place="top"
                    short
                    text="Show"
                >
                  <div 
                      className="data-science__pipeline-creator__body__options__resolver__bottom-row__password__icon"
                      onClick={showPassword}
                  >
                    <Visible
                        color="blue-bright"
                        height={16}
                        width={16}
                    />
                  </div>
                </WithTooltip>
              )}
            </Else>
            </If>
        )}
      </When>
    </div>
  )
}

Password.displayName = "Password"


Password.propTypes = {
  animationEnded: PropTypes.bool,
  dependsOnParam: PropTypes.object,
  extraGroupQuery: PropTypes.string,
  menuPosition: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  validators: PropTypes.array.isRequired,
  value: PropTypes.any.isRequired,
  valueType: PropTypes.string.isRequired, 
  withShowPassword: PropTypes.bool 
}

export default memo(Password);